import { Stack, useTheme } from '@mui/material'
import React, { lazy, Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'
import { AppRoutesRouter } from 'src/app-routes'
import { CenteredSpinner } from 'src/components/Spinner'
import { ProjectPlanningContextProvider } from 'src/context/ProjectPlanningContext'
const ProjectInfoContainer = lazy(async () => await import('src/screens/project/containers/ProjectInfoContainer'))

export const ProjectRoutes = () => {
  const theme = useTheme()
  return (
    <ProjectPlanningContextProvider>
      <Stack
        style={{ backgroundColor: theme.palette.backgroundMain[theme.palette.mode] }}
        width={'100%'}
        minHeight={'calc(100vh - 96px - 85px)'} // 96px for header and 85 px for footer(55px) + 30px padding in the Layout
        className="pb-4-core"
      >
        <Suspense fallback={<CenteredSpinner />}>
          <Routes>
            <Route path={AppRoutesRouter.Project.project} element={<ProjectInfoContainer />} />
            <Route path="*" element={<div></div>} />
          </Routes>
        </Suspense>
      </Stack>
    </ProjectPlanningContextProvider>
  )
}

export default ProjectRoutes
